export const PreFooterQuery = gql`
    query preFooters($canonicalUid: [String]) {
        ds_PreFooterEntries(uid: $canonicalUid) {
            ... on ds_PreFooter_Entry {
                id
                preFooter_ColorTheme
                preFooter_ColorPalette

                preFooter_Alignment
                preFooter_Subheading
                preFooter_Heading
                preFooter_BodyText
                preFooter_Overlay

                preFooter_Links {
                    text
                    target
                    title
                    url
                    ariaLabel
                    ... on preFooter_Links_Custom_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on preFooter_Links_Entry_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on preFooter_Links_Url_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on preFooter_Links_Phone_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on preFooter_Links_Email_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                }
                preFooter_Image {
                    url @transform(width: 1920, height: 400)
                    url_mobile: url @transform(width: 800, height: 400)
                    focalPoint
                }
                preFooter_Buttons {
                    text
                    target
                    title
                    url
                    ariaLabel
                    ... on preFooter_Buttons_Custom_LinkType {
                        buttonStyle
                    }
                    ... on preFooter_Buttons_Entry_LinkType {
                        buttonStyle
                    }
                    ... on preFooter_Buttons_Url_LinkType {
                        buttonStyle
                    }
                    ... on preFooter_Buttons_Phone_LinkType {
                        buttonStyle
                    }
                    ... on preFooter_Buttons_Email_LinkType {
                        buttonStyle
                    }
                }
            }
        }
    }
`
